import { Link as UIKitLink } from '@medely/ui-kit';
import type { ProRoutes } from '@src/routes';

export const Link = UIKitLink<ProRoutes>;
